
export const eraseStroke = (evt, editor, id) => {
  const elemLeft = document.getElementById(id ? id : 'mid_area').getBoundingClientRect().left
  const elemTop = document.getElementById(id? id : 'mid_area').getBoundingClientRect().top
  // const x0 = evt.pageX - elemLeft;
  // const y0 = evt.pageY - elemTop;

  const x0 = evt.changedTouches[0].pageX - elemLeft
  const y0 = evt.changedTouches[0].pageY - elemTop
  const temp = { ...editor };
  let isClear = false;

  temp.lines.forEach((stroke, index) => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < stroke.points.length; i++) {
      if ((stroke.points[i].x >= x0 - 5 && stroke.points[i].x <= x0 + 5) && (stroke.points[i].y >= y0 - 5 && stroke.points[i].y <= y0 + 5)) {
        const e = temp.lines.map((t) => JSON.stringify(t)).indexOf(JSON.stringify(stroke));
        -1 !== e && temp.lines.splice(index, 1);
        // console.log(temp.lines);
        // editor.clear();

        // editor.simulateDrawingLines({ lines: temp.lines, immediate: true });
        // editor.triggerOnChange();
        isClear = true;
      }
    }

  });

  if (isClear) {
    editor.clear();
    editor.simulateDrawingLines({ lines: temp.lines, immediate: true });
    editor.triggerOnChange();
  }
}
